export enum FcdLayerType {
  NONE = 'NONE',
  LEVEL_OF_SERVICE = 'LEVEL_OF_SERVICE',
  CONFIDENCE_VALUE = 'CONFIDENCE_VALUE',
  SPEEDING = 'SPEEDING',
  SLOW_DOWN = 'SLOW_DOWN',
  SPEEDING_LOS = 'SPEEDING_LOS',
  ROUTING_NET = 'ROUTING_NET',
}
